export function hasNewSuccessfulSync(
  firstPoll: boolean,
  latestCompletedId: string | null,
  storedCompletedId: string | null,
): boolean {
  return !firstPoll && latestCompletedId !== null && latestCompletedId !== storedCompletedId;
}

export function shouldRetainTransientActive(
  previous: { job_id: string; status: string; last_heartbeat?: string | null } | null,
  latestCompletedId: string | null,
  consecutiveEmptyPolls: number,
  nowMs: number,
): boolean {
  if (!previous || previous.status !== "running" || latestCompletedId === previous.job_id) {
    return false;
  }
  const heartbeatMs = previous.last_heartbeat
    ? new Date(previous.last_heartbeat).getTime()
    : NaN;
  const heartbeatIsFresh =
    Number.isFinite(heartbeatMs) && nowMs - heartbeatMs < 120_000;
  return heartbeatIsFresh || consecutiveEmptyPolls < 3;
}